import { render } from "./PaymentCart.vue?vue&type=template&id=54b25c8f"
import script from "./PaymentCart.vue?vue&type=script&lang=js"
export * from "./PaymentCart.vue?vue&type=script&lang=js"

import "./PaymentCart.vue?vue&type=style&index=0&id=54b25c8f&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__